import React from 'react';
import T from 'prop-types';

const Silences = ({ silenceDetected, pixelsPerSecond }) => (
  <div className="editor-timeline__silences">
    {silenceDetected.map(silence => (
      <div
        key={`${silence.end}-${silence.duration}`}
        className="editor-timeline__silences__silence"
        style={{
          left: `${pixelsPerSecond * (silence.end - silence.duration)}px`,
          width: `${pixelsPerSecond * silence.duration}px`,
        }}
      />
    ))}
  </div>
);

Silences.propTypes = {
  silenceDetected: T.arrayOf(
    T.shape({
      end: T.number,
      duration: T.number,
    })
  ).isRequired,
  pixelsPerSecond: T.number.isRequired,
};

export default Silences;
